import{jsx as o}from"react/jsx-runtime";import n from"./asssets/content.module.scss";const s=({children:t})=>o("div",{className:n.content,children:t});export{s as Content};
